// ═══ 대행사 거래처 앱 초대 시트 (W1b · 시안 BrokerInvite) — POST /my/malso-clients/:id/invite ═══
// 열기만으로는 발급하지 않는다 — 발급 때 서버가 앞서 보낸 미사용 링크를 만료시키므로 [앱 초대 링크 보내기] 를 눌러야
// POST 1회(components/CancelAgencyInviteModal.js 와 같은 규칙, 발급 중 버튼 비활성). 잔액 줄 없음(YK 초대 시트에만, BRIEF §2).
// 메시지 머리 = 발급한 대행사 이름(issuerName). 오류(400 UNIT_ALREADY_LINKED·UNIT_INACTIVE / 403 / 404) → 토스트 후 닫기.
// 열려 있을 때만 mount 한다. props: { client:{id,name}, showToast, onClose }
import React, { useState } from 'react';
import { T, R, S } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { SheetFrame } from '../../simple/parts/ConfirmSheet';
import { describeSimpleError } from '../../simple/errors';
import { btnNavy, btnDisabled } from '../../simple/screens/request/bits';
import { inviteMalsoClient } from '../api';

var subSt = { fontSize: 13, color: T.muted, textAlign: 'start', marginTop: -6 };
var noteSt = { fontSize: 12.5, color: T.dim, lineHeight: 1.55, wordBreak: 'keep-all' };
var faintSt = { display: 'block', fontSize: 12, color: T.faint, marginTop: 2 };
var msgSt = Object.assign({}, S.textarea, { minHeight: 110, fontSize: 13.5, lineHeight: 1.6, background: T.head });
var issueSt = Object.assign({}, btnNavy, { width: '100%' });
var pair = { display: 'flex', gap: 10 };
var btn = { flex: 1, height: 44, borderRadius: R.lg, fontSize: 14, fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer', minWidth: 0 };
var copySt = Object.assign({}, btn, { border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress });
var shareSt = Object.assign({}, btn, { border: '1px solid ' + T.accent, background: T.accent, color: T.card });

function pad2(n) { return (n < 10 ? '0' : '') + n; }

/// 서버 expiresAt = UTC 'YYYY-MM-DD HH:MM:SS' (Z 없음) → 로컬 'YYYY-MM-DD HH:mm' (CancelAgencyInviteModal 과 같은 변환).
function localExpiry(s) {
  var d = new Date(String(s || '').replace(' ', 'T') + 'Z');
  if (isNaN(d.getTime())) return '';
  return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()) + ' ' + pad2(d.getHours()) + ':' + pad2(d.getMinutes());
}

function MalsoInviteSheet(props) {
  var t = useT();
  var client = props.client || {};
  var showToast = props.showToast || function () {};
  var onClose = props.onClose;
  var stBusy = useState(false); var busy = stBusy[0], setBusy = stBusy[1];
  var stInv = useState(null); var inv = stInv[0], setInv = stInv[1];   // 발급 응답 { url, expiresAt, unitName, agencyName, issuerName }

  var issue = function () {
    if (busy) return;
    setBusy(true);
    inviteMalsoClient(client.id).then(function (d) {
      if (!d || !d.url) throw new Error('');
      setBusy(false);
      setInv(d);
    }).catch(function (e) {
      showToast(describeSimpleError(t, e), 'err');
      onClose();
    });
  };

  var name = (inv && inv.unitName) || client.name || '';
  var msg = inv ? t('malsoModeInviteMessage', { agency: inv.issuerName || '', name: name, url: inv.url }) : '';
  var copy = function () {
    if (!(navigator.clipboard && navigator.clipboard.writeText)) { showToast(t('errorGeneric'), 'err'); return; }
    navigator.clipboard.writeText(inv.url).then(function () { showToast(t('inspListingCopied')); },
      function () { showToast(t('errorGeneric'), 'err'); });
  };
  var share = function () { navigator.share({ text: msg }).catch(function () { /* 사용자 취소 */ }); };

  return (<SheetFrame open title={t('malsoModeInviteTitle')} onClose={onClose} closeLabel={t('actionClose')}>
    <div style={subSt}>{name}</div>
    {inv ? (<React.Fragment>
      <textarea readOnly rows={4} style={msgSt} value={msg} data-testid="invite-message" aria-label={t('malsoModeInviteTitle')} />
      <div style={noteSt}>
        {t('malsoModeBrokerInviteExpires', { name: name, date: localExpiry(inv.expiresAt) })}
        <span style={faintSt}>{t('malsoModeBrokerInviteReissue')}</span>
      </div>
      <div style={pair}>
        <button type="button" style={copySt} data-testid="invite-copy" onClick={copy}>{t('malsoModeInviteCopyLink')}</button>
        {navigator.share ? <button type="button" style={shareSt} data-testid="invite-share" onClick={share}>{t('simpleShare')}</button> : null}
      </div>
    </React.Fragment>) : (<React.Fragment>
      <div style={noteSt}>{t('malsoModeBrokerInviteReissue')}</div>
      <button type="button" style={busy ? Object.assign({}, issueSt, btnDisabled) : issueSt} disabled={busy}
        data-testid="invite-issue" onClick={issue}>{t('malsoModeInviteAction')}</button>
    </React.Fragment>)}
  </SheetFrame>);
}

export default MalsoInviteSheet;
